import CIMSLink from 'components/CIMSLink'
import { PayItemConnection } from '../../ConnectionsContext'

const Source: React.FC<PayItemConnection> = ({ googleSheet }) => {
  if (googleSheet) {
    const { title, url, compositeId } = googleSheet
    return (
      <CIMSLink external href={url}>
        {title ?? compositeId}
      </CIMSLink>
    )
  } else return <>Unknown</>
}

export default Source
